/**
 * RequireAuth — gate for authenticated routes. If the user isn't signed in,
 * redirect to `/auth/signin` (with a return-to hint).
 */

import { Navigate, useLocation } from 'react-router';
import type { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div role="status" aria-live="polite" style={{ padding: 24 }}>
        Checking your session...
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/auth/signin" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
